import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { sectionTitleCapitalization } from 'lib/typography/capitalization-styles'

const useStyles = makeStyles(theme => ({
  root: {
    ...sectionTitleCapitalization,
    fontWeight: 700,
    lineHeight: 1.3,
    margin: 0,
  },
  default: {
    fontSize: '1rem',
  },
  large: {
    fontSize: '1.125rem',
  },
  card: {
    fontSize: '1rem',
    marginBottom: theme.spacing(0.5),
  },
}))

export default function SectionTitle({
  children,
  className,
  component = 'h2',
  size = 'default',
  ...props
}) {
  const classes = useStyles()

  return (
    <Typography
      component={component}
      className={clsx(classes.root, classes[size], className)}
      {...props}
    >
      {children}
    </Typography>
  )
}

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  size: PropTypes.oneOf(['default', 'large', 'card']),
}
